/* eslint-disable */
/* eslint-disable max-lines */ // Fixture data should be excluded from max lines

/** @type {DeliveryEntity} */
export const delivery1Fixture = {
  customer: {
    name: `CITILINK PILING (NSW) PTY LTD`,
  },
  docketId: `1`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `20, WANSEY RD`,
  },
  truckNumber: `10186`,
};

/** @type {DeliveryEntity} */
export const delivery2Fixture = {
  customer: {
    name: `THEMIS CONSTRUCTIONS PTY LTD`,
  },
  docketId: `2`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `9, HOMEDALE AVE`,
  },
  truckNumber: `10845`,
};

/** @type {DeliveryEntity} */
export const delivery3Fixture = {
  customer: {
    name: `THEMIS CONSTRUCTIONS PTY LTD`,
  },
  docketId: `3`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `9, HOMEDALE AVE`,
  },
  truckNumber: `10188`,
};

/** @type {DeliveryEntity} */
export const delivery4Fixture = {
  customer: {
    name: `THEMIS CONSTRUCTIONS PTY LTD`,
  },
  docketId: `4`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `9, HOMEDALE AVE`,
  },
  truckNumber: `10302`,
};

/** @type {DeliveryEntity} */
export const delivery5Fixture = {
  customer: {
    name: `THEMIS CONSTRUCTIONS PTY LTD`,
  },
  docketId: `5`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `9, HOMEDALE AVE`,
  },
  truckNumber: `10188`,
};

/** @type {DeliveryEntity} */
export const delivery6Fixture = {
  customer: {
    name: `THEMIS CONSTRUCTIONS PTY LTD`,
  },
  docketId: `6`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `9, HOMEDALE AVE`,
  },
  truckNumber: `10887`,
};

/** @type {DeliveryEntity} */
export const delivery7Fixture = {
  customer: {
    name: `COD BARRY HAYWOOD`,
  },
  docketId: `7`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `794, MIDDLE TEA TREE RD`,
  },
  truckNumber: `91736`,
};

/** @type {DeliveryEntity} */
export const delivery8Fixture = {
  customer: {
    name: `COD BOB BROWN`,
  },
  docketId: `8`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `CENTRE ST`,
  },
  truckNumber: `20946`,
};

/** @type {DeliveryEntity} */
export const delivery9Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `9`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20309`,
};

/** @type {DeliveryEntity} */
export const delivery10Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `10`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20316`,
};

/** @type {DeliveryEntity} */
export const delivery11Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `11`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20783`,
};

/** @type {DeliveryEntity} */
export const delivery12Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `12`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20309`,
};

/** @type {DeliveryEntity} */
export const delivery13Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `13`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20316`,
};

/** @type {DeliveryEntity} */
export const delivery14Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `14`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20783`,
};

/** @type {DeliveryEntity} */
export const delivery15Fixture = {
  customer: {
    name: `COD ROBERT WARREN`,
  },
  docketId: `15`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `1223 WEABONGA RD`,
  },
  truckNumber: `20335`,
};

/** @type {DeliveryEntity} */
export const delivery16Fixture = {
  customer: {
    name: `COD ROBERT WARREN`,
  },
  docketId: `16`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `1223 WEABONGA RD`,
  },
  truckNumber: `20783`,
};

/** @type {DeliveryEntity} */
export const delivery17Fixture = {
  customer: {
    name: `COD STEVE SYLVESTER`,
  },
  docketId: `17`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `WHOPORIE`,
  },
  truckNumber: `20309`,
};

/** @type {DeliveryEntity} */
export const delivery18Fixture = {
  customer: {
    name: `TUFREYS CONCRETING PLASTERING`,
  },
  docketId: `18`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `EAST WEST PL`,
  },
  truckNumber: `20316`,
};

/** @type {DeliveryEntity} */
export const delivery19Fixture = {
  customer: {
    name: `DEDES, CHRISTOPHER JAMES`,
  },
  docketId: `19`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `84 KENNY DR`,
  },
  truckNumber: `20316`,
};

/** @type {DeliveryEntity} */
export const delivery20Fixture = {
  customer: {
    name: `RICE CONSTRUCTION GROUP PTY LTD`,
  },
  docketId: `20`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `MARIUS ST`,
  },
  truckNumber: `20783`,
};

/** @type {DeliveryEntity} */
export const delivery21Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `21`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10503`,
};

/** @type {DeliveryEntity} */
export const delivery22Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `22`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `SCHEDULED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10306`,
};

/** @type {DeliveryEntity} */
export const delivery23Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `23`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10306`,
};

/** @type {DeliveryEntity} */
export const delivery24Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `24`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `SCHEDULED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10501`,
};

/** @type {DeliveryEntity} */
export const delivery25Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `25`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10501`,
};

/** @type {DeliveryEntity} */
export const delivery26Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `26`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10503`,
};

/** @type {DeliveryEntity} */
export const delivery27Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `27`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10972`,
};

/** @type {DeliveryEntity} */
export const delivery28Fixture = {
  customer: {
    name: `MARCUS MULLIGAN BUILDING`,
  },
  docketId: `28`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `60, BAYVIEW DR`,
  },
  truckNumber: `90590`,
};

/** @type {DeliveryEntity} */
export const delivery29Fixture = {
  customer: {
    name: `MARCUS MULLIGAN BUILDING`,
  },
  docketId: `29`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `60, BAYVIEW DR`,
  },
  truckNumber: `90452`,
};

/** @type {DeliveryEntity} */
export const delivery30Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `30`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20958`,
};

/** @type {DeliveryEntity} */
export const delivery31Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `31`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20951`,
};

/** @type {DeliveryEntity} */
export const delivery32Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `32`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20999`,
};

/** @type {DeliveryEntity} */
export const delivery33Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `33`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20958`,
};

/** @type {DeliveryEntity} */
export const delivery34Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `34`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20948`,
};

/** @type {DeliveryEntity} */
export const delivery35Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `35`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20999`,
};

/** @type {DeliveryEntity} */
export const delivery36Fixture = {
  customer: {
    name: `FAINT G & URQUHART M A`,
  },
  docketId: `36`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `J & K DEPOT MANN ST.`,
  },
  truckNumber: `20951`,
};

/** @type {DeliveryEntity} */
export const delivery37Fixture = {
  customer: {
    name: `AW EDWARDS PTY LTD`,
  },
  docketId: `37`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `NEW ENGLAND HWY`,
  },
  truckNumber: `20958`,
};

/** @type {DeliveryEntity} */
export const delivery38Fixture = {
  customer: {
    name: `AW EDWARDS PTY LTD`,
  },
  docketId: `38`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `NEW ENGLAND HWY`,
  },
  truckNumber: `20951`,
};

/** @type {DeliveryEntity} */
export const delivery39Fixture = {
  customer: {
    name: `HANDEBO, MARK`,
  },
  docketId: `39`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `WATTLE DRIVE`,
  },
  truckNumber: `20999`,
};

/** @type {DeliveryEntity} */
export const delivery40Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `40`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `94740`,
};

/** @type {DeliveryEntity} */
export const delivery41Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `41`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90794`,
};

/** @type {DeliveryEntity} */
export const delivery42Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `42`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90204`,
};

/** @type {DeliveryEntity} */
export const delivery43Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `43`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90416`,
};

/** @type {DeliveryEntity} */
export const delivery44Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `44`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90738`,
};

/** @type {DeliveryEntity} */
export const delivery45Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `45`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `94740`,
};

/** @type {DeliveryEntity} */
export const delivery46Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `46`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90794`,
};

/** @type {DeliveryEntity} */
export const delivery47Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `47`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90204`,
};

/** @type {DeliveryEntity} */
export const delivery48Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `48`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90590`,
};

/** @type {DeliveryEntity} */
export const delivery49Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `49`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90416`,
};

/** @type {DeliveryEntity} */
export const delivery50Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `50`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `94740`,
};

/** @type {DeliveryEntity} */
export const delivery51Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `51`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90794`,
};

/** @type {DeliveryEntity} */
export const delivery52Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `52`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90590`,
};

/** @type {DeliveryEntity} */
export const delivery53Fixture = {
  customer: {
    name: `CEMENTO RAPIDO PTY LTD`,
  },
  docketId: `53`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `SOUTHGATE DR`,
  },
  truckNumber: `90738`,
};

/** @type {DeliveryEntity} */
export const delivery54Fixture = {
  customer: {
    name: `CEMENTO RAPIDO PTY LTD`,
  },
  docketId: `54`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `SOUTHGATE DR`,
  },
  truckNumber: `90416`,
};

/** @type {DeliveryEntity} */
export const delivery55Fixture = {
  customer: {
    name: `CEMENTO RAPIDO PTY LTD`,
  },
  docketId: `55`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `SOUTHGATE DR`,
  },
  truckNumber: `90738`,
};

/** @type {DeliveryEntity} */
export const delivery56Fixture = {
  customer: {
    name: `W VAN DER POLS CONSTRUCTIONS`,
  },
  docketId: `56`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `16, QUARANTINE RD`,
  },
  truckNumber: `90452`,
};

/** @type {DeliveryEntity} */
export const delivery57Fixture = {
  customer: {
    name: `W VAN DER POLS CONSTRUCTIONS`,
  },
  docketId: `57`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `16, QUARANTINE RD`,
  },
  truckNumber: `90204`,
};

/** @type {DeliveryEntity} */
export const delivery58Fixture = {
  customer: {
    name: `W VAN DER POLS CONSTRUCTIONS`,
  },
  docketId: `58`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `16, QUARANTINE RD`,
  },
  truckNumber: `90590`,
};

/** @type {DeliveryEntity} */
export const delivery59Fixture = {
  customer: {
    name: `COD - STUART HOLLOWAY`,
  },
  docketId: `59`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `68, LAWRENCE VALE RD`,
  },
  truckNumber: `90101`,
};

/** @type {DeliveryEntity} */
export const delivery60Fixture = {
  customer: {
    name: `PRODIG TASMANIA`,
  },
  docketId: `60`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `13, CRAIGLANDS CT`,
  },
  truckNumber: `90204`,
};

/** @type {DeliveryEntity} */
export const delivery61Fixture = {
  customer: {
    name: `PRODIG TASMANIA`,
  },
  docketId: `61`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `13, CRAIGLANDS CT`,
  },
  truckNumber: `90794`,
};

/** @type {DeliveryEntity} */
export const delivery62Fixture = {
  customer: {
    name: `GEOFF FOLEY BUILDER PTY LTD`,
  },
  docketId: `62`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `DOWERIN DR`,
  },
  truckNumber: `94740`,
};

/** @type {DeliveryEntity} */
export const delivery63Fixture = {
  customer: {
    name: `GEOFF FOLEY BUILDER PTY LTD`,
  },
  docketId: `63`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `DOWERIN DR`,
  },
  truckNumber: `90794`,
};

/** @type {DeliveryEntity} */
export const delivery64Fixture = {
  customer: {
    name: `GEOFF FOLEY BUILDER PTY LTD`,
  },
  docketId: `64`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `DOWERIN DR`,
  },
  truckNumber: `90452`,
};

/** @type {DeliveryEntity} */
export const delivery65Fixture = {
  customer: {
    name: `COD - METRO SIGNS`,
  },
  docketId: `65`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `123, TALBOT RD`,
  },
  truckNumber: `90101`,
};

/** @type {DeliveryEntity} */
export const delivery66Fixture = {
  customer: {
    name: `CARIO, TONY`,
  },
  docketId: `66`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `2, PICADILLY CT`,
  },
  truckNumber: `90101`,
};

/** @type {DeliveryEntity} */
export const delivery67Fixture = {
  customer: {
    name: `GJ GARDNER HOMES LAUNCESTON`,
  },
  docketId: `67`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `SCHEDULED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `CORELLA DR`,
  },
  truckNumber: `90416`,
};

/** @type {DeliveryEntity} */
export const delivery68Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `68`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20857`,
};

/** @type {DeliveryEntity} */
export const delivery69Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `69`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20420`,
};

/** @type {DeliveryEntity} */
export const delivery70Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `70`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20611`,
};

/** @type {DeliveryEntity} */
export const delivery71Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `71`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20857`,
};

/** @type {DeliveryEntity} */
export const delivery72Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `72`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20420`,
};

/** @type {DeliveryEntity} */
export const delivery73Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `73`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20611`,
};

/** @type {DeliveryEntity} */
export const delivery74Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `74`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20857`,
};

/** @type {DeliveryEntity} */
export const delivery75Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `75`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20420`,
};

/** @type {DeliveryEntity} */
export const delivery76Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `76`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20857`,
};

/** @type {DeliveryEntity} */
export const delivery77Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `77`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20420`,
};

/** @type {DeliveryEntity} */
export const delivery78Fixture = {
  customer: {
    name: `INVERELL SHIRE COUNCIL`,
  },
  docketId: `78`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `GILCHRIST ST`,
  },
  truckNumber: `20857`,
};

/** @type {DeliveryEntity} */
export const delivery79Fixture = {
  customer: {
    name: `PISA CONCRETE POLISHING PTY LTD`,
  },
  docketId: `79`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ALKEIRA CCT`,
  },
  truckNumber: `10228`,
};

/** @type {DeliveryEntity} */
export const delivery80Fixture = {
  customer: {
    name: `PISA CONCRETE POLISHING PTY LTD`,
  },
  docketId: `80`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ALKEIRA CCT`,
  },
  truckNumber: `10228`,
};

/** @type {DeliveryEntity} */
export const delivery81Fixture = {
  customer: {
    name: `PISA CONCRETE POLISHING PTY LTD`,
  },
  docketId: `81`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ALKEIRA CCT`,
  },
  truckNumber: `10859`,
};

/** @type {DeliveryEntity} */
export const delivery82Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `82`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery83Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `83`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery84Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `84`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery85Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `85`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery86Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `86`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery87Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `87`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery88Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `88`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery89Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `89`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery90Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `90`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery91Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `91`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery92Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `92`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery93Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `93`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery94Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `94`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery95Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `95`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery96Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `96`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery97Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `97`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery98Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `98`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery99Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `99`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery100Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `100`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20845`,
};

/** @type {DeliveryEntity} */
export const delivery101Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `101`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20946`,
};

/** @type {DeliveryEntity} */
export const delivery102Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `102`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20781`,
};

/** @type {DeliveryEntity} */
export const delivery103Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `103`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20845`,
};

/** @type {DeliveryEntity} */
export const delivery104Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `104`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20946`,
};

/** @type {DeliveryEntity} */
export const delivery105Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `105`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20781`,
};

/** @type {DeliveryEntity} */
export const delivery106Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `106`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20845`,
};

/** @type {DeliveryEntity} */
export const delivery107Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `107`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20845`,
};

/** @type {DeliveryEntity} */
export const delivery108Fixture = {
  customer: {
    name: `TUFREYS CONCRETING PLASTERING`,
  },
  docketId: `108`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `WHOLE GRAIN MILLERS`,
  },
  truckNumber: `20781`,
};

/** @type {DeliveryEntity} */
export const delivery109Fixture = {
  customer: {
    name: `COD-MIRAGE BUILDERS`,
  },
  docketId: `109`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `1033, RIDGLEY HWY`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery110Fixture = {
  customer: {
    name: `COD-MIRAGE BUILDERS`,
  },
  docketId: `110`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `1033, RIDGLEY HWY`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery111Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `111`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery112Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `112`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery113Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `113`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `94111`,
};

/** @type {DeliveryEntity} */
export const delivery114Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `114`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery115Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `115`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery116Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `116`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery117Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `117`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery118Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `118`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `94111`,
};

/** @type {DeliveryEntity} */
export const delivery119Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `119`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery120Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `120`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery121Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `121`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery122Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `122`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery123Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `123`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery124Fixture = {
  customer: {
    name: `COD-CHRIS ROWE`,
  },
  docketId: `124`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `8, BRADSHAW ST`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery125Fixture = {
  customer: {
    name: `KING & HARDING EXCAVATION & SEAL`,
  },
  docketId: `125`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `10, HELEN ST`,
  },
  truckNumber: `94111`,
};

/** @type {DeliveryEntity} */
export const delivery126Fixture = {
  customer: {
    name: `DEVONPORT CITY COUNCIL`,
  },
  docketId: `126`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `FORMBY RD`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery127Fixture = {
  customer: {
    name: `TRELOAR TRANSPORT`,
  },
  docketId: `127`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `TURNERS LANE`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery128Fixture = {
  customer: {
    name: `COD-BRETT COX`,
  },
  docketId: `128`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `14, CORNWALL RD`,
  },
  truckNumber: `94111`,
};

/** @type {DeliveryEntity} */
export const delivery129Fixture = {
  customer: {
    name: `M & S TEMPLAR`,
  },
  docketId: `129`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `VALLEY RD`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery130Fixture = {
  customer: {
    name: `DEVONPORT CITY COUNCIL`,
  },
  docketId: `130`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STEELE ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery131Fixture = {
  customer: {
    name: `LEIGHTON YORK JOINT VENTURE`,
  },
  docketId: `131`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `GATE S8 SOUTH RD`,
  },
  truckNumber: `50532`,
};

/** @type {DeliveryEntity} */
export const delivery132Fixture = {
  customer: {
    name: `LEIGHTON YORK JOINT VENTURE`,
  },
  docketId: `132`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `GATE S8 SOUTH RD`,
  },
  truckNumber: `51527`,
};

/** @type {DeliveryEntity} */
export const delivery133Fixture = {
  customer: {
    name: `LEIGHTON YORK JOINT VENTURE`,
  },
  docketId: `133`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `GATE S8 SOUTH RD`,
  },
  truckNumber: `50204`,
};

/** @type {DeliveryEntity} */
export const delivery134Fixture = {
  customer: {
    name: `LEIGHTON YORK JOINT VENTURE`,
  },
  docketId: `134`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `GATE S8 SOUTH RD`,
  },
  truckNumber: `50540`,
};

/** @type {DeliveryEntity} */
export const delivery135Fixture = {
  customer: {
    name: `JACKSON BUILDING PTY LTD`,
  },
  docketId: `135`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `55, HENRIETTA ST`,
  },
  truckNumber: `10025`,
};

/** @type {DeliveryEntity} */
export const delivery136Fixture = {
  customer: {
    name: `JACKSON BUILDING PTY LTD`,
  },
  docketId: `136`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `55, HENRIETTA ST`,
  },
  truckNumber: `10525`,
};

/** @type {DeliveryEntity} */
export const delivery137Fixture = {
  customer: {
    name: `JACKSON BUILDING PTY LTD`,
  },
  docketId: `137`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `33 SALISBURY ST`,
  },
  truckNumber: `10427`,
};

/** @type {DeliveryEntity} */
export const delivery138Fixture = {
  customer: {
    name: `STATE CINEMA`,
  },
  docketId: `138`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STRAHAN ST`,
  },
  truckNumber: `90255`,
};

/** @type {DeliveryEntity} */
export const delivery139Fixture = {
  customer: {
    name: `STATE CINEMA`,
  },
  docketId: `139`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STRAHAN ST`,
  },
  truckNumber: `90737`,
};

/** @type {DeliveryEntity} */
export const delivery140Fixture = {
  customer: {
    name: `STATE CINEMA`,
  },
  docketId: `140`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STRAHAN ST`,
  },
  truckNumber: `90065`,
};

/** @type {DeliveryEntity} */
export const delivery141Fixture = {
  customer: {
    name: `STATE CINEMA`,
  },
  docketId: `141`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STRAHAN ST`,
  },
  truckNumber: `90065`,
};

/** @type {DeliveryEntity} */
export const delivery142Fixture = {
  customer: {
    name: `LYONS, DAVID`,
  },
  docketId: `142`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `103, ALLUNGA RD`,
  },
  truckNumber: `90741`,
};

/** @type {DeliveryEntity} */
export const delivery143Fixture = {
  customer: {
    name: `LYONS, DAVID`,
  },
  docketId: `143`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `103, ALLUNGA RD`,
  },
  truckNumber: `90255`,
};

/** @type {DeliveryEntity} */
export const delivery144Fixture = {
  customer: {
    name: `FORESTRY TASMANIA`,
  },
  docketId: `144`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STOREYS RD`,
  },
  truckNumber: `90121`,
};

/** @type {DeliveryEntity} */
export const delivery145Fixture = {
  customer: {
    name: `AHMKDK INVESTMENTS PTY LTD`,
  },
  docketId: `145`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `27, PIRIE ST`,
  },
  truckNumber: `91818`,
};

/** @type {DeliveryEntity} */
export const delivery146Fixture = {
  customer: {
    name: `AHMKDK INVESTMENTS PTY LTD`,
  },
  docketId: `146`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `27, PIRIE ST`,
  },
  truckNumber: `91818`,
};

/** @type {DeliveryEntity} */
export const delivery147Fixture = {
  customer: {
    name: `FULTON HOGAN PTY LTD`,
  },
  docketId: `147`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `HOLYMAN AVE`,
  },
  truckNumber: `90287`,
};

/** @type {DeliveryEntity} */
export const delivery148Fixture = {
  customer: {
    name: `FULTON HOGAN PTY LTD`,
  },
  docketId: `148`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `HOLYMAN AVE`,
  },
  truckNumber: `90289`,
};

/** @type {DeliveryEntity} */
export const delivery149Fixture = {
  customer: {
    name: `COD-BRETT COUGHLAN`,
  },
  docketId: `149`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `175, POTTERY RD`,
  },
  truckNumber: `92833`,
};

/** @type {DeliveryEntity} */
export const delivery150Fixture = {
  customer: {
    name: `COD STUART`,
  },
  docketId: `150`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `49, WELLESLEY ST`,
  },
  truckNumber: `92833`,
};

/** @type {DeliveryEntity} */
export const delivery151Fixture = {
  customer: {
    name: `COD JOHN MOLES`,
  },
  docketId: `151`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `WILTSHIRE PL`,
  },
  truckNumber: `92833`,
};

/** @type {DeliveryEntity} */
export const delivery152Fixture = {
  customer: {
    name: `CLENNS SOUTHERN HARDWARE PTY LTD`,
  },
  docketId: `152`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7, MALUNNA RD, LINDISFARNE`,
  },
  truckNumber: `90253`,
};

/** @type {DeliveryEntity} */
export const delivery153Fixture = {
  customer: {
    name: `HOBART STEEL FIXERS`,
  },
  docketId: `153`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `12, BROADBY DR`,
  },
  truckNumber: `90737`,
};

/** @type {DeliveryEntity} */
export const delivery154Fixture = {
  customer: {
    name: `HOBART STEEL FIXERS`,
  },
  docketId: `154`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `12, BROADBY DR`,
  },
  truckNumber: `90121`,
};

/** @type {DeliveryEntity} */
export const delivery155Fixture = {
  customer: {
    name: `PRECAST TASMANIA PTY LTD`,
  },
  docketId: `155`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: ` COVE HILL RD`,
  },
  truckNumber: `90253`,
};

/** @type {DeliveryEntity} */
export const delivery156Fixture = {
  customer: {
    name: `PRECAST TASMANIA PTY LTD`,
  },
  docketId: `156`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: ` COVE HILL RD`,
  },
  truckNumber: `91736`,
};

/** @type {DeliveryEntity} */
export const delivery157Fixture = {
  customer: {
    name: `PRECAST TASMANIA PTY LTD`,
  },
  docketId: `157`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: ` COVE HILL RD`,
  },
  truckNumber: `90255`,
};

/** @type {DeliveryEntity} */
export const delivery158Fixture = {
  customer: {
    name: `BUILT IT TAS PTY LTD`,
  },
  docketId: `158`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `6, HUME ST`,
  },
  truckNumber: `90741`,
};

/** @type {DeliveryEntity} */
export const delivery159Fixture = {
  customer: {
    name: `STACPOOLE ENTERPRISES PTY LTD`,
  },
  docketId: `159`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `2-6, COLLINS ST`,
  },
  truckNumber: `90741`,
};

/** @type {DeliveryEntity} */
export const delivery160Fixture = {
  customer: {
    name: `VOS CONSTRUCTION AND JOINERY PTY LTD`,
  },
  docketId: `160`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `85, CREEK RD`,
  },
  truckNumber: `90253`,
};

/** @type {DeliveryEntity} */
export const delivery161Fixture = {
  customer: {
    name: `KELLY CIVIL CONTRACTING PTY LTD`,
  },
  docketId: `161`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BROWNING RD`,
  },
  truckNumber: `90253`,
};

/** @type {DeliveryEntity} */
export const delivery162Fixture = {
  customer: {
    name: `SUGARLOAF HEIGHTS PTY LTD`,
  },
  docketId: `162`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `HYDEN RD`,
  },
  truckNumber: `91818`,
};

/** @type {DeliveryEntity} */
export const delivery163Fixture = {
  customer: {
    name: `SHAW CONTRACTING (AUST) PTY LTD`,
  },
  docketId: `163`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `TOLOSA ST`,
  },
  truckNumber: `91736`,
};

/** @type {DeliveryEntity} */
export const delivery164Fixture = {
  customer: {
    name: `KURMOND HOMES PTY LTD`,
  },
  docketId: `164`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 105..NO:213, STONEY CREEK RD`,
  },
  truckNumber: `10133`,
};

/** @type {DeliveryEntity} */
export const delivery165Fixture = {
  customer: {
    name: `KURMOND HOMES PTY LTD`,
  },
  docketId: `165`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 105..NO:213, STONEY CREEK RD`,
  },
  truckNumber: `10581`,
};

/** @type {DeliveryEntity} */
export const delivery166Fixture = {
  customer: {
    name: `KURMOND HOMES PTY LTD`,
  },
  docketId: `166`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 105..NO:213, STONEY CREEK RD`,
  },
  truckNumber: `10599`,
};

/** @type {DeliveryEntity} */
export const delivery167Fixture = {
  customer: {
    name: `KURMOND HOMES PTY LTD`,
  },
  docketId: `167`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 105..NO:213, STONEY CREEK RD`,
  },
  truckNumber: `10581`,
};

/** @type {DeliveryEntity} */
export const delivery168Fixture = {
  customer: {
    name: `KURMOND HOMES PTY LTD`,
  },
  docketId: `168`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 105..NO:213, STONEY CREEK RD`,
  },
  truckNumber: `10134`,
};

/** @type {DeliveryEntity} */
export const delivery169Fixture = {
  customer: {
    name: `SFL/PILETECH (EA) PTY. LTD`,
  },
  docketId: `169`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `22 MAVIS ST`,
  },
  truckNumber: `10193`,
};

/** @type {DeliveryEntity} */
export const delivery170Fixture = {
  customer: {
    name: `SFL/PILETECH (EA) PTY. LTD`,
  },
  docketId: `170`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `22 MAVIS ST`,
  },
  truckNumber: `10601`,
};

/** @type {DeliveryEntity} */
export const delivery171Fixture = {
  customer: {
    name: `SFL/PILETECH (EA) PTY. LTD`,
  },
  docketId: `171`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `22 MAVIS ST`,
  },
  truckNumber: `10191`,
};

/** @type {DeliveryEntity} */
export const delivery172Fixture = {
  customer: {
    name: `SFL/PILETECH (EA) PTY. LTD`,
  },
  docketId: `172`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `22 MAVIS ST`,
  },
  truckNumber: `10252`,
};

/** @type {DeliveryEntity} */
export const delivery173Fixture = {
  customer: {
    name: `CITILINK PILING (NSW) PTY LTD`,
  },
  docketId: `173`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `20, WANSEY RD`,
  },
  truckNumber: `10186`,
};

/** @type {DeliveryEntity} */
export const delivery174Fixture = {
  customer: {
    name: `THEMIS CONSTRUCTIONS PTY LTD`,
  },
  docketId: `174`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `9, HOMEDALE AVE`,
  },
  truckNumber: `10845`,
};

/** @type {DeliveryEntity} */
export const delivery175Fixture = {
  customer: {
    name: `THEMIS CONSTRUCTIONS PTY LTD`,
  },
  docketId: `175`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `9, HOMEDALE AVE`,
  },
  truckNumber: `10188`,
};

/** @type {DeliveryEntity} */
export const delivery176Fixture = {
  customer: {
    name: `THEMIS CONSTRUCTIONS PTY LTD`,
  },
  docketId: `176`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `9, HOMEDALE AVE`,
  },
  truckNumber: `10302`,
};

/** @type {DeliveryEntity} */
export const delivery177Fixture = {
  customer: {
    name: `THEMIS CONSTRUCTIONS PTY LTD`,
  },
  docketId: `177`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `9, HOMEDALE AVE`,
  },
  truckNumber: `10188`,
};

/** @type {DeliveryEntity} */
export const delivery178Fixture = {
  customer: {
    name: `THEMIS CONSTRUCTIONS PTY LTD`,
  },
  docketId: `178`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `9, HOMEDALE AVE`,
  },
  truckNumber: `10887`,
};

/** @type {DeliveryEntity} */
export const delivery179Fixture = {
  customer: {
    name: `COD BARRY HAYWOOD`,
  },
  docketId: `179`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `794, MIDDLE TEA TREE RD`,
  },
  truckNumber: `91736`,
};

/** @type {DeliveryEntity} */
export const delivery180Fixture = {
  customer: {
    name: `COD BOB BROWN`,
  },
  docketId: `180`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `CENTRE ST`,
  },
  truckNumber: `20946`,
};

/** @type {DeliveryEntity} */
export const delivery181Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `181`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20309`,
};

/** @type {DeliveryEntity} */
export const delivery182Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `182`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `LIVE`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20316`,
};

/** @type {DeliveryEntity} */
export const delivery183Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `183`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20783`,
};

/** @type {DeliveryEntity} */
export const delivery184Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `184`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20309`,
};

/** @type {DeliveryEntity} */
export const delivery185Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `185`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20316`,
};

/** @type {DeliveryEntity} */
export const delivery186Fixture = {
  customer: {
    name: `BRAMWELL HOMES PTY LTD`,
  },
  docketId: `186`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7 GOODWIN`,
  },
  truckNumber: `20783`,
};

/** @type {DeliveryEntity} */
export const delivery187Fixture = {
  customer: {
    name: `COD ROBERT WARREN`,
  },
  docketId: `187`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `1223 WEABONGA RD`,
  },
  truckNumber: `20335`,
};

/** @type {DeliveryEntity} */
export const delivery188Fixture = {
  customer: {
    name: `COD ROBERT WARREN`,
  },
  docketId: `188`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `1223 WEABONGA RD`,
  },
  truckNumber: `20783`,
};

/** @type {DeliveryEntity} */
export const delivery189Fixture = {
  customer: {
    name: `COD STEVE SYLVESTER`,
  },
  docketId: `189`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `WHOPORIE`,
  },
  truckNumber: `20309`,
};

/** @type {DeliveryEntity} */
export const delivery190Fixture = {
  customer: {
    name: `TUFREYS CONCRETING PLASTERING`,
  },
  docketId: `190`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `EAST WEST PL`,
  },
  truckNumber: `20316`,
};

/** @type {DeliveryEntity} */
export const delivery191Fixture = {
  customer: {
    name: `DEDES, CHRISTOPHER JAMES`,
  },
  docketId: `191`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `84 KENNY DR`,
  },
  truckNumber: `20316`,
};

/** @type {DeliveryEntity} */
export const delivery192Fixture = {
  customer: {
    name: `RICE CONSTRUCTION GROUP PTY LTD`,
  },
  docketId: `192`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `MARIUS ST`,
  },
  truckNumber: `20783`,
};

/** @type {DeliveryEntity} */
export const delivery193Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `193`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10503`,
};

/** @type {DeliveryEntity} */
export const delivery194Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `194`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `SCHEDULED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10306`,
};

/** @type {DeliveryEntity} */
export const delivery195Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `195`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10306`,
};

/** @type {DeliveryEntity} */
export const delivery196Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `196`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `SCHEDULED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10501`,
};

/** @type {DeliveryEntity} */
export const delivery197Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `197`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10501`,
};

/** @type {DeliveryEntity} */
export const delivery198Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `198`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10503`,
};

/** @type {DeliveryEntity} */
export const delivery199Fixture = {
  customer: {
    name: `I CONSTRUCTION CIVIL PTY LTD`,
  },
  docketId: `199`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `59, HUNTER AVE`,
  },
  truckNumber: `10972`,
};

/** @type {DeliveryEntity} */
export const delivery200Fixture = {
  customer: {
    name: `MARCUS MULLIGAN BUILDING`,
  },
  docketId: `200`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `60, BAYVIEW DR`,
  },
  truckNumber: `90590`,
};

/** @type {DeliveryEntity} */
export const delivery201Fixture = {
  customer: {
    name: `MARCUS MULLIGAN BUILDING`,
  },
  docketId: `201`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `60, BAYVIEW DR`,
  },
  truckNumber: `90452`,
};

/** @type {DeliveryEntity} */
export const delivery202Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `202`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20958`,
};

/** @type {DeliveryEntity} */
export const delivery203Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `203`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20951`,
};

/** @type {DeliveryEntity} */
export const delivery204Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `204`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20999`,
};

/** @type {DeliveryEntity} */
export const delivery205Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `205`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20958`,
};

/** @type {DeliveryEntity} */
export const delivery206Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `206`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20948`,
};

/** @type {DeliveryEntity} */
export const delivery207Fixture = {
  customer: {
    name: `GJ GARDNER HOMES NEW ENGLAND`,
  },
  docketId: `207`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 617 YEOMANS -RD`,
  },
  truckNumber: `20999`,
};

/** @type {DeliveryEntity} */
export const delivery208Fixture = {
  customer: {
    name: `FAINT G & URQUHART M A`,
  },
  docketId: `208`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `J & K DEPOT MANN ST.`,
  },
  truckNumber: `20951`,
};

/** @type {DeliveryEntity} */
export const delivery209Fixture = {
  customer: {
    name: `AW EDWARDS PTY LTD`,
  },
  docketId: `209`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `NEW ENGLAND HWY`,
  },
  truckNumber: `20958`,
};

/** @type {DeliveryEntity} */
export const delivery210Fixture = {
  customer: {
    name: `AW EDWARDS PTY LTD`,
  },
  docketId: `210`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `NEW ENGLAND HWY`,
  },
  truckNumber: `20951`,
};

/** @type {DeliveryEntity} */
export const delivery211Fixture = {
  customer: {
    name: `HANDEBO, MARK`,
  },
  docketId: `211`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `WATTLE DRIVE`,
  },
  truckNumber: `20999`,
};

/** @type {DeliveryEntity} */
export const delivery212Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `212`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `94740`,
};

/** @type {DeliveryEntity} */
export const delivery213Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `213`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90794`,
};

/** @type {DeliveryEntity} */
export const delivery214Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `214`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90204`,
};

/** @type {DeliveryEntity} */
export const delivery215Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `215`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90416`,
};

/** @type {DeliveryEntity} */
export const delivery216Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `216`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90738`,
};

/** @type {DeliveryEntity} */
export const delivery217Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `217`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `94740`,
};

/** @type {DeliveryEntity} */
export const delivery218Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `218`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90794`,
};

/** @type {DeliveryEntity} */
export const delivery219Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `219`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90204`,
};

/** @type {DeliveryEntity} */
export const delivery220Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `220`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90590`,
};

/** @type {DeliveryEntity} */
export const delivery221Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `221`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90416`,
};

/** @type {DeliveryEntity} */
export const delivery222Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `222`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `94740`,
};

/** @type {DeliveryEntity} */
export const delivery223Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `223`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90794`,
};

/** @type {DeliveryEntity} */
export const delivery224Fixture = {
  customer: {
    name: `EDGE HOMES`,
  },
  docketId: `224`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `74, PEDDIE DR`,
  },
  truckNumber: `90590`,
};

/** @type {DeliveryEntity} */
export const delivery225Fixture = {
  customer: {
    name: `CEMENTO RAPIDO PTY LTD`,
  },
  docketId: `225`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `SOUTHGATE DR`,
  },
  truckNumber: `90738`,
};

/** @type {DeliveryEntity} */
export const delivery226Fixture = {
  customer: {
    name: `CEMENTO RAPIDO PTY LTD`,
  },
  docketId: `226`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `SOUTHGATE DR`,
  },
  truckNumber: `90416`,
};

/** @type {DeliveryEntity} */
export const delivery227Fixture = {
  customer: {
    name: `CEMENTO RAPIDO PTY LTD`,
  },
  docketId: `227`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `SOUTHGATE DR`,
  },
  truckNumber: `90738`,
};

/** @type {DeliveryEntity} */
export const delivery228Fixture = {
  customer: {
    name: `W VAN DER POLS CONSTRUCTIONS`,
  },
  docketId: `228`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `16, QUARANTINE RD`,
  },
  truckNumber: `90452`,
};

/** @type {DeliveryEntity} */
export const delivery229Fixture = {
  customer: {
    name: `W VAN DER POLS CONSTRUCTIONS`,
  },
  docketId: `229`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `16, QUARANTINE RD`,
  },
  truckNumber: `90204`,
};

/** @type {DeliveryEntity} */
export const delivery230Fixture = {
  customer: {
    name: `W VAN DER POLS CONSTRUCTIONS`,
  },
  docketId: `230`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `16, QUARANTINE RD`,
  },
  truckNumber: `90590`,
};

/** @type {DeliveryEntity} */
export const delivery231Fixture = {
  customer: {
    name: `COD - STUART HOLLOWAY`,
  },
  docketId: `231`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `68, LAWRENCE VALE RD`,
  },
  truckNumber: `90101`,
};

/** @type {DeliveryEntity} */
export const delivery232Fixture = {
  customer: {
    name: `PRODIG TASMANIA`,
  },
  docketId: `232`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `13, CRAIGLANDS CT`,
  },
  truckNumber: `90204`,
};

/** @type {DeliveryEntity} */
export const delivery233Fixture = {
  customer: {
    name: `PRODIG TASMANIA`,
  },
  docketId: `233`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `13, CRAIGLANDS CT`,
  },
  truckNumber: `90794`,
};

/** @type {DeliveryEntity} */
export const delivery234Fixture = {
  customer: {
    name: `GEOFF FOLEY BUILDER PTY LTD`,
  },
  docketId: `234`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `DOWERIN DR`,
  },
  truckNumber: `94740`,
};

/** @type {DeliveryEntity} */
export const delivery235Fixture = {
  customer: {
    name: `GEOFF FOLEY BUILDER PTY LTD`,
  },
  docketId: `235`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `DOWERIN DR`,
  },
  truckNumber: `90794`,
};

/** @type {DeliveryEntity} */
export const delivery236Fixture = {
  customer: {
    name: `GEOFF FOLEY BUILDER PTY LTD`,
  },
  docketId: `236`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `DOWERIN DR`,
  },
  truckNumber: `90452`,
};

/** @type {DeliveryEntity} */
export const delivery237Fixture = {
  customer: {
    name: `COD - METRO SIGNS`,
  },
  docketId: `237`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `123, TALBOT RD`,
  },
  truckNumber: `90101`,
};

/** @type {DeliveryEntity} */
export const delivery238Fixture = {
  customer: {
    name: `CARIO, TONY`,
  },
  docketId: `238`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `2, PICADILLY CT`,
  },
  truckNumber: `90101`,
};

/** @type {DeliveryEntity} */
export const delivery239Fixture = {
  customer: {
    name: `GJ GARDNER HOMES LAUNCESTON`,
  },
  docketId: `239`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `SCHEDULED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `CORELLA DR`,
  },
  truckNumber: `90416`,
};

/** @type {DeliveryEntity} */
export const delivery240Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `240`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20857`,
};

/** @type {DeliveryEntity} */
export const delivery241Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `241`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20420`,
};

/** @type {DeliveryEntity} */
export const delivery242Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `242`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20611`,
};

/** @type {DeliveryEntity} */
export const delivery243Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `243`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20857`,
};

/** @type {DeliveryEntity} */
export const delivery244Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `244`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20420`,
};

/** @type {DeliveryEntity} */
export const delivery245Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `245`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20611`,
};

/** @type {DeliveryEntity} */
export const delivery246Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `246`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20857`,
};

/** @type {DeliveryEntity} */
export const delivery247Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `247`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20420`,
};

/** @type {DeliveryEntity} */
export const delivery248Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `248`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20857`,
};

/** @type {DeliveryEntity} */
export const delivery249Fixture = {
  customer: {
    name: `BROWETT BUILDING`,
  },
  docketId: `249`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `COPETON DAM RD`,
  },
  truckNumber: `20420`,
};

/** @type {DeliveryEntity} */
export const delivery250Fixture = {
  customer: {
    name: `INVERELL SHIRE COUNCIL`,
  },
  docketId: `250`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `GILCHRIST ST`,
  },
  truckNumber: `20857`,
};

/** @type {DeliveryEntity} */
export const delivery251Fixture = {
  customer: {
    name: `PISA CONCRETE POLISHING PTY LTD`,
  },
  docketId: `251`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ALKEIRA CCT`,
  },
  truckNumber: `10228`,
};

/** @type {DeliveryEntity} */
export const delivery252Fixture = {
  customer: {
    name: `PISA CONCRETE POLISHING PTY LTD`,
  },
  docketId: `252`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ALKEIRA CCT`,
  },
  truckNumber: `10228`,
};

/** @type {DeliveryEntity} */
export const delivery253Fixture = {
  customer: {
    name: `PISA CONCRETE POLISHING PTY LTD`,
  },
  docketId: `253`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ALKEIRA CCT`,
  },
  truckNumber: `10859`,
};

/** @type {DeliveryEntity} */
export const delivery254Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `254`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery255Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `255`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery256Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `256`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery257Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `257`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery258Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `258`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery259Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `259`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery260Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `260`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery261Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `261`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery262Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `262`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery263Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `263`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery264Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `264`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery265Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `265`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery266Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `266`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery267Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `267`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery268Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `268`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery269Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `269`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94461`,
};

/** @type {DeliveryEntity} */
export const delivery270Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `270`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery271Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `271`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `ORMSBY ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery272Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `272`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20845`,
};

/** @type {DeliveryEntity} */
export const delivery273Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `273`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20946`,
};

/** @type {DeliveryEntity} */
export const delivery274Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `274`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20781`,
};

/** @type {DeliveryEntity} */
export const delivery275Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `275`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20845`,
};

/** @type {DeliveryEntity} */
export const delivery276Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `276`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20946`,
};

/** @type {DeliveryEntity} */
export const delivery277Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `277`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20781`,
};

/** @type {DeliveryEntity} */
export const delivery278Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `278`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20845`,
};

/** @type {DeliveryEntity} */
export const delivery279Fixture = {
  customer: {
    name: `GJ GARDNER HOMES (TAMWORTH)`,
  },
  docketId: `279`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 32 , 14 DENORA AVENUE`,
  },
  truckNumber: `20845`,
};

/** @type {DeliveryEntity} */
export const delivery280Fixture = {
  customer: {
    name: `TUFREYS CONCRETING PLASTERING`,
  },
  docketId: `280`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `WHOLE GRAIN MILLERS`,
  },
  truckNumber: `20781`,
};

/** @type {DeliveryEntity} */
export const delivery281Fixture = {
  customer: {
    name: `COD-MIRAGE BUILDERS`,
  },
  docketId: `281`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `1033, RIDGLEY HWY`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery282Fixture = {
  customer: {
    name: `COD-MIRAGE BUILDERS`,
  },
  docketId: `282`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `1033, RIDGLEY HWY`,
  },
  truckNumber: `94460`,
};

/** @type {DeliveryEntity} */
export const delivery283Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `283`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery284Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `284`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery285Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `285`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `94111`,
};

/** @type {DeliveryEntity} */
export const delivery286Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `286`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery287Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `287`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `90254`,
};

/** @type {DeliveryEntity} */
export const delivery288Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `288`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery289Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `289`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery290Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `290`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `94111`,
};

/** @type {DeliveryEntity} */
export const delivery291Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `291`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery292Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `292`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery293Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `293`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery294Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `294`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery295Fixture = {
  customer: {
    name: `FAIRBROTHER PTY LTD-STONYRISE ROAD`,
  },
  docketId: `295`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BEST ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery296Fixture = {
  customer: {
    name: `COD-CHRIS ROWE`,
  },
  docketId: `296`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `8, BRADSHAW ST`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery297Fixture = {
  customer: {
    name: `KING & HARDING EXCAVATION & SEAL`,
  },
  docketId: `297`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `10, HELEN ST`,
  },
  truckNumber: `94111`,
};

/** @type {DeliveryEntity} */
export const delivery298Fixture = {
  customer: {
    name: `DEVONPORT CITY COUNCIL`,
  },
  docketId: `298`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `FORMBY RD`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery299Fixture = {
  customer: {
    name: `TRELOAR TRANSPORT`,
  },
  docketId: `299`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `TURNERS LANE`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery300Fixture = {
  customer: {
    name: `COD-BRETT COX`,
  },
  docketId: `300`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `14, CORNWALL RD`,
  },
  truckNumber: `94111`,
};

/** @type {DeliveryEntity} */
export const delivery301Fixture = {
  customer: {
    name: `M & S TEMPLAR`,
  },
  docketId: `301`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `VALLEY RD`,
  },
  truckNumber: `91744`,
};

/** @type {DeliveryEntity} */
export const delivery302Fixture = {
  customer: {
    name: `DEVONPORT CITY COUNCIL`,
  },
  docketId: `302`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STEELE ST`,
  },
  truckNumber: `91115`,
};

/** @type {DeliveryEntity} */
export const delivery303Fixture = {
  customer: {
    name: `LEIGHTON YORK JOINT VENTURE`,
  },
  docketId: `303`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `GATE S8 SOUTH RD`,
  },
  truckNumber: `50532`,
};

/** @type {DeliveryEntity} */
export const delivery304Fixture = {
  customer: {
    name: `LEIGHTON YORK JOINT VENTURE`,
  },
  docketId: `304`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `GATE S8 SOUTH RD`,
  },
  truckNumber: `51527`,
};

/** @type {DeliveryEntity} */
export const delivery305Fixture = {
  customer: {
    name: `LEIGHTON YORK JOINT VENTURE`,
  },
  docketId: `305`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `GATE S8 SOUTH RD`,
  },
  truckNumber: `50204`,
};

/** @type {DeliveryEntity} */
export const delivery306Fixture = {
  customer: {
    name: `LEIGHTON YORK JOINT VENTURE`,
  },
  docketId: `306`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `GATE S8 SOUTH RD`,
  },
  truckNumber: `50540`,
};

/** @type {DeliveryEntity} */
export const delivery307Fixture = {
  customer: {
    name: `JACKSON BUILDING PTY LTD`,
  },
  docketId: `307`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `55, HENRIETTA ST`,
  },
  truckNumber: `10025`,
};

/** @type {DeliveryEntity} */
export const delivery308Fixture = {
  customer: {
    name: `JACKSON BUILDING PTY LTD`,
  },
  docketId: `308`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `55, HENRIETTA ST`,
  },
  truckNumber: `10525`,
};

/** @type {DeliveryEntity} */
export const delivery309Fixture = {
  customer: {
    name: `JACKSON BUILDING PTY LTD`,
  },
  docketId: `309`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `33 SALISBURY ST`,
  },
  truckNumber: `10427`,
};

/** @type {DeliveryEntity} */
export const delivery310Fixture = {
  customer: {
    name: `STATE CINEMA`,
  },
  docketId: `310`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STRAHAN ST`,
  },
  truckNumber: `90255`,
};

/** @type {DeliveryEntity} */
export const delivery311Fixture = {
  customer: {
    name: `STATE CINEMA`,
  },
  docketId: `311`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STRAHAN ST`,
  },
  truckNumber: `90737`,
};

/** @type {DeliveryEntity} */
export const delivery312Fixture = {
  customer: {
    name: `STATE CINEMA`,
  },
  docketId: `312`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STRAHAN ST`,
  },
  truckNumber: `90065`,
};

/** @type {DeliveryEntity} */
export const delivery313Fixture = {
  customer: {
    name: `STATE CINEMA`,
  },
  docketId: `313`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STRAHAN ST`,
  },
  truckNumber: `90065`,
};

/** @type {DeliveryEntity} */
export const delivery314Fixture = {
  customer: {
    name: `LYONS, DAVID`,
  },
  docketId: `314`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `103, ALLUNGA RD`,
  },
  truckNumber: `90741`,
};

/** @type {DeliveryEntity} */
export const delivery315Fixture = {
  customer: {
    name: `LYONS, DAVID`,
  },
  docketId: `315`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `103, ALLUNGA RD`,
  },
  truckNumber: `90255`,
};

/** @type {DeliveryEntity} */
export const delivery316Fixture = {
  customer: {
    name: `FORESTRY TASMANIA`,
  },
  docketId: `316`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `STOREYS RD`,
  },
  truckNumber: `90121`,
};

/** @type {DeliveryEntity} */
export const delivery317Fixture = {
  customer: {
    name: `AHMKDK INVESTMENTS PTY LTD`,
  },
  docketId: `317`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `27, PIRIE ST`,
  },
  truckNumber: `91818`,
};

/** @type {DeliveryEntity} */
export const delivery318Fixture = {
  customer: {
    name: `AHMKDK INVESTMENTS PTY LTD`,
  },
  docketId: `318`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `27, PIRIE ST`,
  },
  truckNumber: `91818`,
};

/** @type {DeliveryEntity} */
export const delivery319Fixture = {
  customer: {
    name: `FULTON HOGAN PTY LTD`,
  },
  docketId: `319`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `HOLYMAN AVE`,
  },
  truckNumber: `90287`,
};

/** @type {DeliveryEntity} */
export const delivery320Fixture = {
  customer: {
    name: `FULTON HOGAN PTY LTD`,
  },
  docketId: `320`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `HOLYMAN AVE`,
  },
  truckNumber: `90289`,
};

/** @type {DeliveryEntity} */
export const delivery321Fixture = {
  customer: {
    name: `COD-BRETT COUGHLAN`,
  },
  docketId: `321`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `175, POTTERY RD`,
  },
  truckNumber: `92833`,
};

/** @type {DeliveryEntity} */
export const delivery322Fixture = {
  customer: {
    name: `COD STUART`,
  },
  docketId: `322`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `49, WELLESLEY ST`,
  },
  truckNumber: `92833`,
};

/** @type {DeliveryEntity} */
export const delivery323Fixture = {
  customer: {
    name: `COD JOHN MOLES`,
  },
  docketId: `323`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `WILTSHIRE PL`,
  },
  truckNumber: `92833`,
};

/** @type {DeliveryEntity} */
export const delivery324Fixture = {
  customer: {
    name: `CLENNS SOUTHERN HARDWARE PTY LTD`,
  },
  docketId: `324`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `7, MALUNNA RD, LINDISFARNE`,
  },
  truckNumber: `90253`,
};

/** @type {DeliveryEntity} */
export const delivery325Fixture = {
  customer: {
    name: `HOBART STEEL FIXERS`,
  },
  docketId: `325`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `12, BROADBY DR`,
  },
  truckNumber: `90737`,
};

/** @type {DeliveryEntity} */
export const delivery326Fixture = {
  customer: {
    name: `HOBART STEEL FIXERS`,
  },
  docketId: `326`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `12, BROADBY DR`,
  },
  truckNumber: `90121`,
};

/** @type {DeliveryEntity} */
export const delivery327Fixture = {
  customer: {
    name: `PRECAST TASMANIA PTY LTD`,
  },
  docketId: `327`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: ` COVE HILL RD`,
  },
  truckNumber: `90253`,
};

/** @type {DeliveryEntity} */
export const delivery328Fixture = {
  customer: {
    name: `PRECAST TASMANIA PTY LTD`,
  },
  docketId: `328`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: ` COVE HILL RD`,
  },
  truckNumber: `91736`,
};

/** @type {DeliveryEntity} */
export const delivery329Fixture = {
  customer: {
    name: `PRECAST TASMANIA PTY LTD`,
  },
  docketId: `329`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: ` COVE HILL RD`,
  },
  truckNumber: `90255`,
};

/** @type {DeliveryEntity} */
export const delivery330Fixture = {
  customer: {
    name: `BUILT IT TAS PTY LTD`,
  },
  docketId: `330`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `6, HUME ST`,
  },
  truckNumber: `90741`,
};

/** @type {DeliveryEntity} */
export const delivery331Fixture = {
  customer: {
    name: `STACPOOLE ENTERPRISES PTY LTD`,
  },
  docketId: `331`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `2-6, COLLINS ST`,
  },
  truckNumber: `90741`,
};

/** @type {DeliveryEntity} */
export const delivery332Fixture = {
  customer: {
    name: `VOS CONSTRUCTION AND JOINERY PTY LTD`,
  },
  docketId: `332`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `85, CREEK RD`,
  },
  truckNumber: `90253`,
};

/** @type {DeliveryEntity} */
export const delivery333Fixture = {
  customer: {
    name: `KELLY CIVIL CONTRACTING PTY LTD`,
  },
  docketId: `333`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `BROWNING RD`,
  },
  truckNumber: `90253`,
};

/** @type {DeliveryEntity} */
export const delivery334Fixture = {
  customer: {
    name: `SUGARLOAF HEIGHTS PTY LTD`,
  },
  docketId: `334`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `HYDEN RD`,
  },
  truckNumber: `91818`,
};

/** @type {DeliveryEntity} */
export const delivery335Fixture = {
  customer: {
    name: `SHAW CONTRACTING (AUST) PTY LTD`,
  },
  docketId: `335`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `TOLOSA ST`,
  },
  truckNumber: `91736`,
};

/** @type {DeliveryEntity} */
export const delivery336Fixture = {
  customer: {
    name: `KURMOND HOMES PTY LTD`,
  },
  docketId: `336`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 105..NO:213, STONEY CREEK RD`,
  },
  truckNumber: `10133`,
};

/** @type {DeliveryEntity} */
export const delivery337Fixture = {
  customer: {
    name: `KURMOND HOMES PTY LTD`,
  },
  docketId: `337`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 105..NO:213, STONEY CREEK RD`,
  },
  truckNumber: `10581`,
};

/** @type {DeliveryEntity} */
export const delivery338Fixture = {
  customer: {
    name: `KURMOND HOMES PTY LTD`,
  },
  docketId: `338`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 105..NO:213, STONEY CREEK RD`,
  },
  truckNumber: `10599`,
};

/** @type {DeliveryEntity} */
export const delivery339Fixture = {
  customer: {
    name: `KURMOND HOMES PTY LTD`,
  },
  docketId: `339`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 105..NO:213, STONEY CREEK RD`,
  },
  truckNumber: `10581`,
};

/** @type {DeliveryEntity} */
export const delivery340Fixture = {
  customer: {
    name: `KURMOND HOMES PTY LTD`,
  },
  docketId: `340`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `LOT 105..NO:213, STONEY CREEK RD`,
  },
  truckNumber: `10134`,
};

/** @type {DeliveryEntity} */
export const delivery341Fixture = {
  customer: {
    name: `SFL/PILETECH (EA) PTY. LTD`,
  },
  docketId: `341`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `22 MAVIS ST`,
  },
  truckNumber: `10193`,
};

/** @type {DeliveryEntity} */
export const delivery342Fixture = {
  customer: {
    name: `SFL/PILETECH (EA) PTY. LTD`,
  },
  docketId: `342`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `22 MAVIS ST`,
  },
  truckNumber: `10601`,
};

/** @type {DeliveryEntity} */
export const delivery343Fixture = {
  customer: {
    name: `SFL/PILETECH (EA) PTY. LTD`,
  },
  docketId: `343`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `COMPLETED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `22 MAVIS ST`,
  },
  truckNumber: `10191`,
};

/** @type {DeliveryEntity} */
export const delivery344Fixture = {
  customer: {
    name: `SFL/PILETECH (EA) PTY. LTD`,
  },
  docketId: `344`,
  docketTime: `23/AUG/18`,
  instructions: {
    comments: `Instructions comments`,
    followTruckId: `1234`,
  },
  order: {
    status: `DELIVERED`,
  },
  plant: {
    geo: {
      lat: `123`,
      lon: `123`,
    },
  },
  product: {
    additives: null,
    aggregatedSize: 1234,
    name: `product description`,
    slump: `90`,
  },
  quantity: {
    progress: 123,
    total: 234,
  },
  site: {
    address: `22 MAVIS ST`,
  },
  truckNumber: `10252`,
};

/** @type {Array<DeliveryEntity>} */
export const deliveriesFixture = [
  delivery1Fixture,
  delivery2Fixture,
  delivery3Fixture,
  delivery4Fixture,
  delivery5Fixture,
  delivery6Fixture,
  delivery7Fixture,
  delivery8Fixture,
  delivery9Fixture,
  delivery10Fixture,
  delivery11Fixture,
  delivery12Fixture,
  delivery13Fixture,
  delivery14Fixture,
  delivery15Fixture,
  delivery16Fixture,
  delivery17Fixture,
  delivery18Fixture,
  delivery19Fixture,
  delivery20Fixture,
  delivery21Fixture,
  delivery22Fixture,
  delivery23Fixture,
  delivery24Fixture,
  delivery25Fixture,
  delivery26Fixture,
  delivery27Fixture,
  delivery28Fixture,
  delivery29Fixture,
  delivery30Fixture,
  delivery31Fixture,
  delivery32Fixture,
  delivery33Fixture,
  delivery34Fixture,
  delivery35Fixture,
  delivery36Fixture,
  delivery37Fixture,
  delivery38Fixture,
  delivery39Fixture,
  delivery40Fixture,
  delivery41Fixture,
  delivery42Fixture,
  delivery43Fixture,
  delivery44Fixture,
  delivery45Fixture,
  delivery46Fixture,
  delivery47Fixture,
  delivery48Fixture,
  delivery49Fixture,
  delivery50Fixture,
  delivery51Fixture,
  delivery52Fixture,
  delivery53Fixture,
  delivery54Fixture,
  delivery55Fixture,
  delivery56Fixture,
  delivery57Fixture,
  delivery58Fixture,
  delivery59Fixture,
  delivery60Fixture,
  delivery61Fixture,
  delivery62Fixture,
  delivery63Fixture,
  delivery64Fixture,
  delivery65Fixture,
  delivery66Fixture,
  delivery67Fixture,
  delivery68Fixture,
  delivery69Fixture,
  delivery70Fixture,
  delivery71Fixture,
  delivery72Fixture,
  delivery73Fixture,
  delivery74Fixture,
  delivery75Fixture,
  delivery76Fixture,
  delivery77Fixture,
  delivery78Fixture,
  delivery79Fixture,
  delivery80Fixture,
  delivery81Fixture,
  delivery82Fixture,
  delivery83Fixture,
  delivery84Fixture,
  delivery85Fixture,
  delivery86Fixture,
  delivery87Fixture,
  delivery88Fixture,
  delivery89Fixture,
  delivery90Fixture,
  delivery91Fixture,
  delivery92Fixture,
  delivery93Fixture,
  delivery94Fixture,
  delivery95Fixture,
  delivery96Fixture,
  delivery97Fixture,
  delivery98Fixture,
  delivery99Fixture,
  delivery100Fixture,
  delivery101Fixture,
  delivery102Fixture,
  delivery103Fixture,
  delivery104Fixture,
  delivery105Fixture,
  delivery106Fixture,
  delivery107Fixture,
  delivery108Fixture,
  delivery109Fixture,
  delivery110Fixture,
  delivery111Fixture,
  delivery112Fixture,
  delivery113Fixture,
  delivery114Fixture,
  delivery115Fixture,
  delivery116Fixture,
  delivery117Fixture,
  delivery118Fixture,
  delivery119Fixture,
  delivery120Fixture,
  delivery121Fixture,
  delivery122Fixture,
  delivery123Fixture,
  delivery124Fixture,
  delivery125Fixture,
  delivery126Fixture,
  delivery127Fixture,
  delivery128Fixture,
  delivery129Fixture,
  delivery130Fixture,
  delivery131Fixture,
  delivery132Fixture,
  delivery133Fixture,
  delivery134Fixture,
  delivery135Fixture,
  delivery136Fixture,
  delivery137Fixture,
  delivery138Fixture,
  delivery139Fixture,
  delivery140Fixture,
  delivery141Fixture,
  delivery142Fixture,
  delivery143Fixture,
  delivery144Fixture,
  delivery145Fixture,
  delivery146Fixture,
  delivery147Fixture,
  delivery148Fixture,
  delivery149Fixture,
  delivery150Fixture,
  delivery151Fixture,
  delivery152Fixture,
  delivery153Fixture,
  delivery154Fixture,
  delivery155Fixture,
  delivery156Fixture,
  delivery157Fixture,
  delivery158Fixture,
  delivery159Fixture,
  delivery160Fixture,
  delivery161Fixture,
  delivery162Fixture,
  delivery163Fixture,
  delivery164Fixture,
  delivery165Fixture,
  delivery166Fixture,
  delivery167Fixture,
  delivery168Fixture,
  delivery169Fixture,
  delivery170Fixture,
  delivery171Fixture,
  delivery172Fixture,
  delivery173Fixture,
  delivery174Fixture,
  delivery175Fixture,
  delivery176Fixture,
  delivery177Fixture,
  delivery178Fixture,
  delivery179Fixture,
  delivery180Fixture,
  delivery181Fixture,
  delivery182Fixture,
  delivery183Fixture,
  delivery184Fixture,
  delivery185Fixture,
  delivery186Fixture,
  delivery187Fixture,
  delivery188Fixture,
  delivery189Fixture,
  delivery190Fixture,
  delivery191Fixture,
  delivery192Fixture,
  delivery193Fixture,
  delivery194Fixture,
  delivery195Fixture,
  delivery196Fixture,
  delivery197Fixture,
  delivery198Fixture,
  delivery199Fixture,
  delivery200Fixture,
  delivery201Fixture,
  delivery202Fixture,
  delivery203Fixture,
  delivery204Fixture,
  delivery205Fixture,
  delivery206Fixture,
  delivery207Fixture,
  delivery208Fixture,
  delivery209Fixture,
  delivery210Fixture,
  delivery211Fixture,
  delivery212Fixture,
  delivery213Fixture,
  delivery214Fixture,
  delivery215Fixture,
  delivery216Fixture,
  delivery217Fixture,
  delivery218Fixture,
  delivery219Fixture,
  delivery220Fixture,
  delivery221Fixture,
  delivery222Fixture,
  delivery223Fixture,
  delivery224Fixture,
  delivery225Fixture,
  delivery226Fixture,
  delivery227Fixture,
  delivery228Fixture,
  delivery229Fixture,
  delivery230Fixture,
  delivery231Fixture,
  delivery232Fixture,
  delivery233Fixture,
  delivery234Fixture,
  delivery235Fixture,
  delivery236Fixture,
  delivery237Fixture,
  delivery238Fixture,
  delivery239Fixture,
  delivery240Fixture,
  delivery241Fixture,
  delivery242Fixture,
  delivery243Fixture,
  delivery244Fixture,
  delivery245Fixture,
  delivery246Fixture,
  delivery247Fixture,
  delivery248Fixture,
  delivery249Fixture,
  delivery250Fixture,
  delivery251Fixture,
  delivery252Fixture,
  delivery253Fixture,
  delivery254Fixture,
  delivery255Fixture,
  delivery256Fixture,
  delivery257Fixture,
  delivery258Fixture,
  delivery259Fixture,
  delivery260Fixture,
  delivery261Fixture,
  delivery262Fixture,
  delivery263Fixture,
  delivery264Fixture,
  delivery265Fixture,
  delivery266Fixture,
  delivery267Fixture,
  delivery268Fixture,
  delivery269Fixture,
  delivery270Fixture,
  delivery271Fixture,
  delivery272Fixture,
  delivery273Fixture,
  delivery274Fixture,
  delivery275Fixture,
  delivery276Fixture,
  delivery277Fixture,
  delivery278Fixture,
  delivery279Fixture,
  delivery280Fixture,
  delivery281Fixture,
  delivery282Fixture,
  delivery283Fixture,
  delivery284Fixture,
  delivery285Fixture,
  delivery286Fixture,
  delivery287Fixture,
  delivery288Fixture,
  delivery289Fixture,
  delivery290Fixture,
  delivery291Fixture,
  delivery292Fixture,
  delivery293Fixture,
  delivery294Fixture,
  delivery295Fixture,
  delivery296Fixture,
  delivery297Fixture,
  delivery298Fixture,
  delivery299Fixture,
  delivery300Fixture,
  delivery301Fixture,
  delivery302Fixture,
  delivery303Fixture,
  delivery304Fixture,
  delivery305Fixture,
  delivery306Fixture,
  delivery307Fixture,
  delivery308Fixture,
  delivery309Fixture,
  delivery310Fixture,
  delivery311Fixture,
  delivery312Fixture,
  delivery313Fixture,
  delivery314Fixture,
  delivery315Fixture,
  delivery316Fixture,
  delivery317Fixture,
  delivery318Fixture,
  delivery319Fixture,
  delivery320Fixture,
  delivery321Fixture,
  delivery322Fixture,
  delivery323Fixture,
  delivery324Fixture,
  delivery325Fixture,
  delivery326Fixture,
  delivery327Fixture,
  delivery328Fixture,
  delivery329Fixture,
  delivery330Fixture,
  delivery331Fixture,
  delivery332Fixture,
  delivery333Fixture,
  delivery334Fixture,
  delivery335Fixture,
  delivery336Fixture,
  delivery337Fixture,
  delivery338Fixture,
  delivery339Fixture,
  delivery340Fixture,
  delivery341Fixture,
  delivery342Fixture,
  delivery343Fixture,
  delivery344Fixture,
];
